export default {
  data() {
    return {
      invalidInputs: [],
      validationMessages: [],
      validationRules: {},
    };
  },
  computed: {
    isValid() {
      let valid = true;
      if (this.invalidInputs.length !== 0) valid = false;
      this.validationMessages = [];

      // When this mixin is used, the user can set Validation Rules.
      // They set these in the component using this mixin.
      Object.keys(this.validationRules).forEach((validationRuleKey) => {
        const validationRule = this.validationRules[validationRuleKey];
        if (!validationRule().condition) {
          this.validationMessages.push(validationRule().message);
          valid = false;
        }
      });

      return valid;
    },
  },
  methods: {
    showWhichInputsAreInvalid(scrollFirstInvalidInputInToView) {
      // Compile list of VueComponents that are invalid.
      const inValidComponents = [];
      Object.keys(this.validationRules).forEach((validationRuleKey) => {
        const validationRule = this.validationRules[validationRuleKey];
        if (!validationRule().condition && validationRule().scrollToElement) {
          inValidComponents.push(validationRule().scrollToElement);
        }
      });
      this.invalidInputs.forEach((invalidInput) => {
        inValidComponents.push(invalidInput);
        if (invalidInput.showWhichInputsAreInvalid) {
          invalidInput.showWhichInputsAreInvalid(false);
        } else {
          invalidInput.showInvalidMessage();
        }
      });
      // Scroll to component with lowest ID that's invalid.
      if (scrollFirstInvalidInputInToView !== false && inValidComponents[0]) {
        inValidComponents.sort(
          (a, b) =>
            a.$el.getBoundingClientRect().top -
            b.$el.getBoundingClientRect().top
        );
        inValidComponents[0].$el.scrollIntoView();
        if (typeof window === "undefined") return;
        window.scrollBy(0, -100);
      }
    },
  },
  beforeMount() {
    // Listen to the validChange emit emitted from InputBase.js
    this.$on("validChange", (input, inputIsBeingDestroyed) => {
      if (input.isValid || inputIsBeingDestroyed === true) {
        // Remove Input from invalidInputs Array.
        this.invalidInputs = this.invalidInputs.filter(
          (object) => object !== input
        );
        this.$emit("isValid", this);
      } else {
        // Add Input to invalidInputs array
        this.invalidInputs.push(input);
        this.$emit("isInvalid", this);
      }
    });
  },
  watch: {
    isValid() {
      this.$parent.$emit("validChange", this);
    },
  },
};
